const getGlobalState = (state, key) => (Array.isArray(state.teams[key]) ? state.teams[key].slice(0) : state.teams[key]);

export const getCompetitorsFromState = (state) => getGlobalState(state, 'competitors');
export const getPlayersFromState = (state) => getGlobalState(state, 'players');

export const getSelectedPlayers = (state) => getGlobalState(state, 'selectedPlayers');

export const getLiveTemplateFile = (state) => getGlobalState(state, 'liveTemplateFiles');
export const getDownloadedLiveTemplateFile = (state) => getGlobalState(state, 'downloadedLiveTemplateFile');
export const getLiveTemplate = (state) => getGlobalState(state, 'liveTemplates');
export const getTennisLiveTemplate = (state) => getGlobalState(state, 'tennisLiveTemplates');
export const getTennisLiveTemplateFile = (state) => getGlobalState(state, 'tennisliveTemplateFiles');
export const getTennisDownloadedLiveTemplateFile = (state) => getGlobalState(state, 'downloadedTennisLiveTemplateFile');
export const getPlayersTemplate = (state) => getGlobalState(state, 'playersTemplate');
export const getPlayersTemplateFile = (state) => getGlobalState(state, 'templateFiles');
export const getDownloadedTemplateFile = (state) => getGlobalState(state, 'downloadedTemplateFile');
export const getPlayersTemplatePreview = (state) => getGlobalState(state, 'playersTemplatePreview');

